import React, { Component } from 'react';


import firebase from '../firebase';
import FileUploader from "react-firebase-file-uploader";
import { toast } from 'react-toastify';
import { AtomSpinner } from 'react-epic-spinners';
import {Row} from 'shards-react';

export default class FileUpload extends Component{

	constructor(props) {
	  super(props);
	
	  this.state = {isUploading:false,progress:0};

    this.date = new Date();
    this.string_date = this.date.getDate()+"-"+(this.date.getMonth()+1)+"-"+(this.date.getFullYear());
	}




	/*FIREBASE STORAGE */
  handleUploadStart = () => this.setState({ isUploading: true, progress: 0 });
  handleProgress = progress => this.setState({ progress });
  handleUploadError = error => {
    	this.setState({ isUploading: false });
    	toast("Error uploading Photo");
    	window.alert("Photo not uploaded");
    	console.error(error);
  };


  handleUploadSuccess = filename => {
  	var that = this;
    this.setState({ filename: filename, progress: 100, isUploading: false });
      firebase
      .storage()
      .ref("Posts/"+this.string_date)
      .child(filename)
      .getDownloadURL()
      .then(url => {
      		//..handle url
      		that.props.update_url(url);
      });


   
  };
	render(){

    

		return(


  				<div className="custom-file mb-3">	

  					{!this.state.isUploading &&
  						<div>
          				<FileUploader 

            				accept="image/*"
            				name="avatar"
            				randomizeFilename
            				storageRef={firebase.storage().ref("Posts/"+this.string_date)}
            				onUploadStart={this.handleUploadStart}
            				onUploadError={this.handleUploadError}
            				onUploadSuccess={this.handleUploadSuccess}
            				onProgress={this.handleProgress}
            				className="custom-file-input"
          				/>
          				<label className="custom-file-label" htmlFor="customFile2">
      						Choose file...
    					</label>
    					</div>
    				}


          				{this.state.isUploading && 
          				<div style={{marginLeft: '5%'}}>
                    		<Row>
                        			<AtomSpinner color="blue" />
                        			<h3 style={{marginLeft: '5%',marginTop: '5%'}}>Uploading...</h3>            
                    		</Row>
                    	</div>
          				}
				
				</div>
			)
	}
}




